/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Full_NameInputs */

const en_admin_external_booking_edit_full_name = /** @type {(inputs: Admin_External_Booking_Edit_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full name`)
};

const de_admin_external_booking_edit_full_name = /** @type {(inputs: Admin_External_Booking_Edit_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständiger Name`)
};

const es_admin_external_booking_edit_full_name = /** @type {(inputs: Admin_External_Booking_Edit_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre completo`)
};

const fr_admin_external_booking_edit_full_name = /** @type {(inputs: Admin_External_Booking_Edit_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom complet`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Full_NameInputs) => LocalizedString} */
const it_admin_external_booking_edit_full_name = en_admin_external_booking_edit_full_name;

/** @type {(inputs: Admin_External_Booking_Edit_Full_NameInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_full_name = en_admin_external_booking_edit_full_name;

/** @type {(inputs: Admin_External_Booking_Edit_Full_NameInputs) => LocalizedString} */
const pl_admin_external_booking_edit_full_name = en_admin_external_booking_edit_full_name;

/** @type {(inputs: Admin_External_Booking_Edit_Full_NameInputs) => LocalizedString} */
const hu_admin_external_booking_edit_full_name = en_admin_external_booking_edit_full_name;

/** @type {(inputs: Admin_External_Booking_Edit_Full_NameInputs) => LocalizedString} */
const ro_admin_external_booking_edit_full_name = en_admin_external_booking_edit_full_name;

/**
* | output |
* | --- |
* | "Full name" |
*
* @param {Admin_External_Booking_Edit_Full_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_full_name = /** @type {((inputs?: Admin_External_Booking_Edit_Full_NameInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Full_NameInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_full_name(inputs)
	if (locale === "de") return de_admin_external_booking_edit_full_name(inputs)
	if (locale === "es") return es_admin_external_booking_edit_full_name(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_full_name(inputs)
	if (locale === "it") return it_admin_external_booking_edit_full_name(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_full_name(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_full_name(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_full_name(inputs)
	return ro_admin_external_booking_edit_full_name(inputs)
});
export { admin_external_booking_edit_full_name as "admin.external_booking_edit.full_name" }